<template>
  <ODialog ref="dialog" hideWhenLoading>
    <v-card v-if="row != null">
      <OperationDialogTitle v-bind="row" @close="dismiss" />

      <v-card-text class="pa-3">
        <v-form
          ref="theForm"
          v-model="isValid"
          class="d-flex flex-wrap items-start"
        >
          <OCapCont class="w-full pa-3" label="Veículo">
            <ReadonlyVehicle
              v-if="vehicle != null"
              :vehicle="vehicle"
              :history="activeInstall"
            />
          </OCapCont>

          <ODateTimeInput2
            :readonly="readonly"
            class="w-full pa-3"
            v-model="row.timestamp"
            label="Data/hora do registro"
            :clearable="false"
          />

          <OAlert info class="w-full ma-3" v-if="lastTicket != null">
            Último ticket:
            <LastTicket :value="lastTicket" />
          </OAlert>

          <OTextField
            :readonly="readonly"
            class="w-full pa-3 mt-8"
            v-model="row.ticketNumber"
            label="Número do ticket do Zendesk"
            :rules="[isSet, numbersOnly]"
            filled
            autofocus
            @enter="apply"
            ref="theInput"
          />

          <RowDates class="ma-3" :value="row" />
        </v-form>
      </v-card-text>

      <ODialogButtons class="pa-6" @cancel="dismiss" @apply="apply" />
    </v-card>
  </ODialog>
</template>

<script>
import TheUser from 'oderon-vue/auth/TheUser'
import LastTicket from '@/components/LastTicket.vue'
import RowDates from './RowDates.vue'
import { ClientHistory, InstalledBase } from '@/models'
import { isSet, numbersOnly } from 'oderon-vue/utils.js'
import ReadonlyVehicle from './ReadonlyVehicle.vue'
import { postOrPatch, findActiveInstall, canEdit } from './operation-utils'
import OperationDialogTitle from './OperationDialogTitle.vue'

export default {
  components: { LastTicket, ReadonlyVehicle, RowDates, OperationDialogTitle },
  data() {
    return {
      ...this.reset(),
      isSet,
      numbersOnly,
      TheUser
    }
  },
  computed: {
    readonly() {
      return this.row && this.row.id && !canEdit(this.TheUser)
    }
  },
  methods: {
    reset() {
      return {
        isValid: false,
        row: null,

        // Veículo sendo exibido (não é possível escolher)
        vehicle: null,

        // Histórico para facilitar visualização do veículo
        // (só usado na criação de novo registro; e.g. para
        // saber se foi "instalado há 20 dias")
        activeInstall: null,

        // Traz o último ticket associado (possivelmente por
        // este próprio registro, se estivermos editando um)
        lastTicket: null
      }
    },

    open({ clientId, historyId }) {
      Object.assign(this, this.reset())

      if (this.$refs.theForm) this.$refs.theForm.resetValidation()

      this.$refs.dialog.$loading(() => this.fetchData(clientId, historyId))

      return this.$refs.dialog.$open()
    },

    async fetchData(clientId, historyId) {
      if (historyId == null) {
        // usamos activeInstall porque não faz sentido associar
        // ticket pra módulos que não estão instalados.
        let activeInstall = await findActiveInstall(clientId)
        this.row = {
          type: 'associateTicket',
          timestamp: new Date(),
          clientId: clientId,
          ticketNumber: null,
          vehicleId: activeInstall && activeInstall.vehicleId
        }

        // Usado apenas para mostrar no ReadonlyVehicle
        this.activeInstall = activeInstall
        this.vehicle = activeInstall && activeInstall.vehicle
      } else {
        this.row = await ClientHistory.findById(historyId)
        this.row.ticketNumber = this.row.comments

        // usado para exibição readonly
        this.vehicle = this.row.vehicle

        // NB: this.activeInstall fica null, pois o veículo
        // acima pode não ser o mesmo do último install se
        // estamos editando um registro antigo
      }

      let pair = await InstalledBase.findPrimaryByCid(clientId)
      if (pair != null) {
        this.lastTicket = pair.client.lastTicket
      }
    },

    apply() {
      if (this.$refs.theForm.validate()) {
        this.$refs.dialog.$loading(async () => {
          await postOrPatch('/clients/:cid/associateTicket', this.row)
          this.$snack('Registro salvo com sucesso')
          this.$refs.dialog.$apply('RELOAD')
        })
      }
    },

    dismiss() {
      this.$refs.dialog.$dismiss()
    }
  }
}
</script>

<style></style>
